<template>
  <div class="size-full">
    <div v-on:click="toggleVisibility" v-bind:class="`${alignment}`">
      <div v-if="svgElement == 'circle'">
        <div class="fees-and-conditions__circle">
          <span v-if="!showFeesAndConditions">+</span><span v-else>-</span>
        </div>
        <span class="fees-and-conditions__title numeral --calibre-regular">{{
          title
        }}</span>
      </div>
      <div v-else-if="svgElement == 'caret'">
        <span class="fees-and-conditions__title numeral --calibre-regular">{{
          title
        }}</span>
        <div class="fees-and-conditions__caret">
          <span>
            <svg
              v-bind:class="{ up: showFeesAndConditions }"
              width="10px"
              height="10px"
              viewBox="0 0 7 4"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill=""
                fill-rule="evenodd"
              >
                <g
                  id="Icons"
                  transform="translate(-134.000000, -43.000000)"
                  fill=""
                >
                  <polygon
                    id="caret-small-down"
                    points="134.707107 43 134 43.6965437 137.353553 47 140.707107 43.6965437 140 43 137.358734 45.6018093"
                  ></polygon>
                </g>
              </g>
            </svg>
          </span>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div>
        <template v-for="(value, key) in items">
          <div
            :key="key"
            v-if="showItem(value, key)"
            class="fees-conditions__content grid numeral --calibre-regular +border-bottom"
          >
            <div
              class="grid-cell size-4of12 fees-conditions__property +text-left"
            >
              {{ key }}
            </div>
            <div class="grid-cell size-8of12 fees-conditions__value +text-left">
              {{ value }}
            </div>
          </div>
        </template>
      </div>
    </transition>
    <transition name="fade">
      <div
        class="grid-cell size-full fees-and-conditions__footnote"
        v-if="finalvalue && showFeesAndConditions"
      >
        {{ finalvalue }}
      </div>
    </transition>
  </div>
</template>

<script>
//////////////////////////////////////////////////////////////////////////////
//////// @DEPRECATED - Rewrite or clean up for any future use ////////////////
//////////////////////////////////////////////////////////////////////////////

import eventHub from '../bankrate-events/index'

export default {
  props: {
    title: {
      default: function() {
        return ''
      }
    },
    alignment: {
      type: String,
      default: '+text-left'
    },
    svgElement: {
      type: String,
      default: 'circle'
    },
    items: {
      default: function() {
        return []
      }
    },
    finalvalue: {
      default: ''
    }
  },

  data: function() {
    return {
      showFeesAndConditions: false
    }
  },

  methods: {
    toggleVisibility: function() {
      this.showFeesAndConditions = !this.showFeesAndConditions
      if (this.showFeesAndConditions === true) {
        // GA tracking for clicking "offer details"
        eventHub.$emit('rateTable.offerDetails')
      }
    },

    showItem: function(value, key) {
      // only show fee, condition and autoDebit not empty value
      return (
        this.showFeesAndConditions &&
        value &&
        key.toLowerCase() !== 'relationship'
      )
    }
  }
}
</script>

<style lang="scss">
@import '../../../sass/brcom/settings/_settings.global.scss';
@import '../../../sass/brcom/settings/_settings.theme-colors.scss';
@import '../../../sass/brcom/tools/_tools.rem.scss';
.fees-conditions__content {
  font-family: $global-body-font-calibre;
  @include rem(font-size, 14px);
  padding: rem(3px) 0;
  margin-top: 10px;
}

.fees-conditions__property {
  color: $theme-gray-dark;
  @include rem(font-size, 14px);
  padding-left: 5px;
}

.fees-conditions__value {
  font-size: 16px;
  padding-left: 5px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease, max-height 0.2s ease;
  max-height: 999px;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
  max-height: 0;
}

.fees-and-conditions__title {
  color: $theme-gray-dark;
  font-size: 14px;
  &:hover {
    cursor: pointer;
  }
}

.fees-and-conditions__circle {
  background: $theme-gray;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  position: relative;
  text-align: center;
  top: 4px;
  width: 20px;
  span {
    position: relative;
    top: -5px;
  }
  &:hover {
    background: $theme-blue-light;
  }
}

.fees-and-conditions__caret {
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  height: 20px;
  position: relative;
  text-align: center;
  top: 5px;
  width: 20px;
  span {
    position: relative;
    top: -5px;
  }
  &:hover {
    background: $theme-blue-light;
  }

  svg.up {
    transform: rotate(180deg);
  }
}

.fees-and-conditions__footnote {
  @include rem(font-size, 14px);
  color: $theme-gray-dark;
  font-family: $global-body-font-calibre;
  padding-top: 5px;
}
</style>
